import { api } from '@/api.js';
import { config } from '@/config.js';
import { useDocumentDownload } from '@/composables/admin/documentos/useDocumentDownload';

/**
 * Helper local equivalente al `toValue` de Vue 3.3+ (no disponible en Vue 2.7).
 * Acepta indistintamente un valor primitivo, un getter o una `ref` y devuelve
 * el valor actual en cada llamada.
 */
function toValue(valueOrRefOrGetter) {
    if (typeof valueOrRefOrGetter === 'function') {
        return valueOrRefOrGetter();
    }
    if (valueOrRefOrGetter && typeof valueOrRefOrGetter === 'object' && 'value' in valueOrRefOrGetter) {
        return valueOrRefOrGetter.value;
    }
    return valueOrRefOrGetter;
}

/**
 * Fetcher y composable de descarga de documentos para deportistas (bases).
 *
 * GET /api1/listas-abonados/{lista_id}/bases/{base_id}/documento/{documento_id}/descargar
 * Mismo patrón que abonados: backend hace de proxy same-origin, sin CORS.
 *
 * Los IDs se reciben como refs/getters/valores para que el composable los lea
 * en CADA descarga. Si la vista se reutiliza al cambiar de deportista sin
 * remontar el componente, los identificadores pueden quedar obsoletos;
 * pasarlos reactivos evita el acoplamiento temporal.
 *
 * @param {number|string|Ref|() => number|string} listaId
 *   ID de la lista (o ref/getter que lo devuelve).
 * @param {number|string|Ref|() => number|string} baseId
 *   ID de la base (o ref/getter que lo devuelve).
 * @returns {{ download: Function, loading: Ref<boolean> }}
 */
export function useBaseDocumentDownload(listaId, baseId) {
    async function baseFetcher(documento) {
        return api.call(
            config.getAPIRoute('back.bases.descargar.documento'),
            {
                filters: {},
                lista_id: toValue(listaId),
                base_id: toValue(baseId),
                documento_id: documento.id,
            },
            { responseType: 'blob' }
        );
    }

    return useDocumentDownload(baseFetcher);
}